import { VirtualListRef } from '@unistocks/components/virtual-list/list';
import { DashboardItemDto } from '@unistocks/proxy/axios-client';
import { Key } from 'react';
import { Card, GetProps, styled } from 'tamagui';

export const DashboardItemFrame = styled(Card, {
  name: 'DashboardItemFrame',
  backgroundColor: '$color2',
  gap: '$2',
  p: '$3',
  elevation: '$0.25',
  overflow: 'hidden',

  $sm: {
    gap: 0
  }
});

export type DashboardItemLayout = ReturnType<VirtualListRef<DashboardItemDto>['getLayout']>;

type DashboardItemFrameProps = Omit<GetProps<typeof DashboardItemFrame>, 'key'>;

export type DashboardItemProps = DashboardItemFrameProps & {
  key?: Key | null;
  item: DashboardItemDto;
  itemLayout?: DashboardItemLayout;
  openSettings: (item: DashboardItemDto, title?: string) => void;
};
